const backArrow = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="0 8.05 4.55 12.61 4.55 8.78 15.0046844 8.78 15.0046844 7.22 4.55 7.22 4.55 3.5"/></svg>',
};

export { backArrow as default };
